export const NAME_DEFAULT = 'count';



// WEBPACK FOOTER //
// ./src/pages/profile/components/selectcount/const.ts